import { injectReducer } from "store/reducers";
import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";
import CircularDetails from "Circulars/routes/CircularDetails";
export default store => ({
  path: "circulars",
  component: withAsyncRouteLoading(
    () =>
      Promise.all([
        import(
          /* webpackChunkName: "administrator-communications" */ "Circulars/modules/CircularsContainer"
        ),
        import(
          /* webpackChunkName: "administrator-communications" */ "Circulars/modules/CircularsModule"
        ),
      ]).then(([importedModule0, importedModule1]) => {
        const component = importedModule0.default;
        const module2 = importedModule1;
        const reducer = module2.default;
        const key = module2.NAME;
        injectReducer(store, {
          key,
          reducer,
        });
        return component;
      })
    //.catch(err => {
    //   throw err;
    // })
  ),
  childRoutes: [CircularDetails(store)],
});
